import { Component, OnInit, Input, Output, EventEmitter, Directive, HostBinding } from '@angular/core';
import { BaseService } from '@app/system/services/base.service';
import { AssignmentCard } from '../utilities/models/assignment-card-model';

@Component({
	selector: 'app-assignment-card',
	templateUrl: './assignment-card.component.html',
	styleUrls: ['./assignment-card.component.scss']
})
export class AssignmentCardComponent implements OnInit {
	@Input() data: AssignmentCard;
	@Output() detail: any = new EventEmitter();

	constructor(
		private baseService: BaseService,
	) { }

	ngOnInit(): void { }

	info(record) {
		if (navigator.onLine) {
			this.detail.emit(record);
		}
	}
	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}
}

@Directive({
	selector: 'content-area'
})
export class AssignmentCardContentArea {
	@HostBinding('style.height') private height = '100%';
}
